import { render, staticRenderFns } from "./MediaPopup.vue?vue&type=template&id=2c44cfbc&scoped=true&"
import script from "./MediaPopup.vue?vue&type=script&lang=ts&"
export * from "./MediaPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c44cfbc",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDataTable,VDialog})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c44cfbc')) {
      api.createRecord('2c44cfbc', component.options)
    } else {
      api.reload('2c44cfbc', component.options)
    }
    module.hot.accept("./MediaPopup.vue?vue&type=template&id=2c44cfbc&scoped=true&", function () {
      api.rerender('2c44cfbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/digitalSignage/MediaPopup.vue"
export default component.exports